import { render, staticRenderFns } from "./checklist-items-list.vue?vue&type=template&id=38d832b2&"
import script from "./checklist-items-list.vue?vue&type=script&lang=ts&"
export * from "./checklist-items-list.vue?vue&type=script&lang=ts&"
import style0 from "./checklist-items-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports